import { SAVE_SELECTED_PRODUCT } from "Constants/redux";

export const saveSelectedInventoryProduct = (product) =>{
  return (dispatch)=>{
    dispatch({
      type:SAVE_SELECTED_PRODUCT,
      payload:product
    })
  }
}